import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: '/sign_in'
  },
  {
    path: '/sign_in',
    name: 'sign-in',
    props: true,
    component: () => import('@/views/SignIn')
  },
  {
    path: '/sign_up',
    name: 'sign-up',
    props: true,
    component: () => import('@/views/SignUp')
  },
  {
    path: '/regist/agent',
    name: 'regist-agent',
    props: true,
    component: () => import('@/views/BaseView')
  },
  {
    path: '/regist/user',
    name: 'regist-user',
    props: true,
    component: () => import('@/views/BaseView')
  },
  {
    path: '/mypage',
    name: 'mypage',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/achievements',
    name: 'achievements',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/achievements/:yyyymm',
    name: 'achievements-month',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/invited_spowers',
    name: 'invited-spowers',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/unmatched_orders',
    name: 'unmatched-orders',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/orders',
    name: 'company-orders',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/orders/create',
    name: 'company-order-create',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/orders/create/:formatId',
    name: 'company-order-create-format',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/orders/batch_create',
    name: 'company-order-batch-create',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/orders/batch_check',
    name: 'company-order-batch-check',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/orders/batch_create/:formatId',
    name: 'company-order-batch-create-format',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/orders/completed',
    name: 'company-order-completed',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/orders/:orderId',
    name: 'company-order-detail',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/orders/:orderId/works/:workId',
    name: 'company-work-detail',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/spots',
    name: 'company-spots',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/spots/batch_create',
    name: 'company-spot-batch-create',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/spots/:spotId',
    name: 'company-spot-detail',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/messages',
    name: 'company-message-list',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/messages/:messageRoomId',
    name: 'company-message',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/unread_messages',
    name: 'company-unread-message-list',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/text_field_ng_lists',
    name: 'company-text-field-ng-lists',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/text_field_ng_list/create',
    name: 'company-text-field-ng-list-create',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/text_field_ng_list/edit/:ngListId',
    name: 'company-text-field-ng-list-edit',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/schedules',
    name: 'company-schedules',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/schedules/create',
    name: 'company-schedule-create',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/schedules/batch_create',
    name: 'company-schedule-batch-create',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/schedules/:scheduleId',
    name: 'company-schedule-detail',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/offers',
    name: 'company-offers',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/spowers',
    name: 'company-spowers',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/search_spowers',
    name: 'company-search-spowers',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/spowers/:accessibleUserId',
    name: 'company-spower-detail',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/r/:r',
    name: 'redirect',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/formats',
    name: 'company-formats',
    component: () => import('@/views/BaseView')
  },
  {
    // /formats/createは最終的にはformats/edit/と同じコンポーネントに行くが、idを受け取らない
    // 互換性維持のために存在し、将来的に削除予定
    path: '/company/:companyId/formats/create',
    name: 'company-format-create',
    component: () => import('@/views/BaseView')
  },
  {
    // /formats/createは最終的にはformats/edit/と同じコンポーネントに行くが、idを受け取らない
    // 互換性維持のために存在し、将来的に削除予定
    path: '/company/:companyId/formats/default/:formatId',
    name: 'company-default-format',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/formats/edit/:formatId',
    name: 'company-format-edit',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/formats/detail/:formatId',
    name: 'company-format-detail',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/recruit_requirements',
    name: 'company-recruit-requirements',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/recruit_requirements/create',
    name: 'company-recruit-requirement-create',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/recruit_requirements/:recruitRequirementId',
    name: 'company-recruit-requirement-detail',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/recruit_requirements/:recruitRequirementId/interests',
    name: 'company-recruit-requirement-interests',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/rounder_cards',
    name: 'company-rounder-cards',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/rounder_cards/create',
    name: 'company-rounder-card-create',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/rounder_cards/:rounderCardId',
    name: 'company-rounder-card-detail',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/licenses',
    name: 'company-licenses',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/licenses/create',
    name: 'company-license-create',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/licenses/:licenseId',
    name: 'company-license-detail',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/licenses/:licenseId/test',
    name: 'company-license-test',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/licenses/:licenseId/test/submissions/:submissionId',
    name: 'company-license-test-submission-detail',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/seminars',
    name: 'company-seminars',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/seminars/create',
    name: 'company-seminar-create',
    component: () => import('@/views/BaseView')
  },
  {
    path: '/company/:companyId/seminars/:seminarId',
    name: 'company-seminar-detail',
    component: () => import('@/views/BaseView')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
